export default "__VITE_ASSET__gEyQD1Kf__"